module.exports = __webpack_public_path__ + "img/birthday_eve_ribbon.2bfddba4.svg";